import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UserListComponent } from '../../list/user-list/user-list.component';

@Component({
  selector: 'sn-usc-user-lookup',
  templateUrl: './usc-user-lookup.component.html',
  styleUrls: ['../usc-modal/usc-modal.component.css', './usc-user-lookup.component.css']
})
export class UscUserLookupComponent implements OnInit {
    @Input() lookup_scope: string;

  constructor(
    public activeModal: NgbActiveModal,    
  ) { }

  selectedUser:any;
  showError:boolean = false;
  
  ngOnInit() {
  }

  selectEvent(e) {
    if (this.selectedUser == undefined || this.selectedUser.selectedItem.ID != e.selectedItem.ID) {
      this.selectedUser = e;
      this.showError = false;
    } else {
      this.selectedUser = undefined;
    }
  }

  confirm() {
    if (this.selectedUser) {
      this.activeModal.close(this.selectedUser);
    }
    this.showError = true;
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-user-lookup/usc-user-lookup.component.ts